import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { token } from '@atlaskit/tokens';

const SKELETON_APP_TILE_COUNT = 3;

// Widths and height mirror the controls in `row-width.ts` and `RefreshFilterRow`.
const styles = cssMap({
	row: {
		height: '32px',
	},
	allApps: {
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderRadius: token('radius.medium'),
		height: '32px',
		width: '96px',
		flexShrink: 0,
	},
	appTile: {
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderRadius: token('radius.medium'),
		height: '32px',
		width: '124px',
		flexShrink: 0,
	},
	filtersControl: {
		backgroundColor: token('color.background.accent.gray.subtlest'),
		borderRadius: token('radius.medium'),
		height: '32px',
		width: '32px',
		flexShrink: 0,
	},
});

export const RefreshFilterRowSkeleton = (): React.JSX.Element => (
	<Inline
		spread="space-between"
		alignBlock="center"
		xcss={styles.row}
		testId="search-page-refresh-filter-row-skeleton"
	>
		<Inline space="space.075" alignBlock="center">
			<Box xcss={styles.allApps} />
			{Array.from({ length: SKELETON_APP_TILE_COUNT }, (_, index) => (
				<Box key={index} xcss={styles.appTile} />
			))}
		</Inline>
		<Box xcss={styles.filtersControl} />
	</Inline>
);
